import React from 'react';
import { stub } from '@xsk/frontend-skeleton';

class SalesDataDetail extends React.Component {
    render() {
        return <stub.ui.DetailPage module="collection" sceenKey='collection-salesData-detail' {...this.props} />
    }

}

export default SalesDataDetail;
